


import axios from "axios";
import { health_api } from "../../Config";
import { decryptData } from "../../Framework/Utils/decrypt.js"
import {encryptData} from "../../Framework/Utils/encrypt.js"

let API_URL = `${health_api}/insurance/v1/health/policy/kyc/verification`;

let Hdfc_Api_Url = `https://1umwbwg2b7.execute-api.ap-south-1.amazonaws.com/Prod/insurance/v1/health/policy/hdfcKycVerification`;


export const uploadKycDocument = async (data) => {
  try {
    const response = await axios.post(
      "https://c4vygufp78.execute-api.ap-south-1.amazonaws.com/Prod/insurance/v1/health/kyc-uploaded",
      data
    );
    console.log(response, "response in line 14");
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyKyc = async (provider, data) => {
  try {
    let encrytedData=encryptData(data)
    const response = await axios.post(API_URL,{payload:encrytedData});
    console.log(response, data, "response in line number 30");
    const decryptedData = decryptData(response?.data);
    console.log(decryptedData, "kycVerify in 34");
    switch (provider) {
      case "bajaj":
        try {
          return decryptedData;
        } catch (error) {
          console.error("Error during BAJAJ proposal submission:", error);
        }
        break;

      case "CARE":
        try {
          console.log(response, "response in line 14");
          return decryptedData?.data;
        } catch (error) {
          console.log(error);
        }
        break;
      case "RELIANCE":
        try{
          return decryptedData;
        }catch(error){
          console.log(error);
        }
        break;

      default:
        console.error("Unsupported provider:", provider);
    }
  } catch (error) {
    console.error("Error during KYC verification:", error);
  }
};

export const hdfcVerifyKyc = async (data) => {
  try {
    let encrytedData=encryptData(data)
    const response = await axios.post(Hdfc_Api_Url, {payload:encrytedData});
    console.log(response,"nkjhkjfhd")
    const decryptedData = decryptData(response?.data);
    console.log(decryptedData,"qHJHASKJHERUKHIUA")
    return decryptedData;
  } catch (error) {
    console.log(error);
  }
};
export const HdfcKycCall = async (params, provider) => {
  let postData = {
    name: params.proposerData.firstname,
    phone: params.proposerData.mobile,
    dob: params.proposerData.birthDate,
    provider: "HDFC",
  };
  let encrytedData=encryptData(postData)
  console.log(encrytedData,"suhdskjhdskj")
  console.log(params, "usyuidysiu");
  try {

    console.log("Calling HDFC KYC API with data:", postData);
    const response = await hdfcVerifyKyc(params);
    console.log(response, "response in line 14");
    const responseData = JSON.parse(response?.body); 
    console.log(responseData,"sdhsdjhj")



   
    const KycData = responseData?.data;  
     const name=KycData?.name;
    const dob=KycData?.dob;
    const kycId = KycData?.kyc_id;
    const adress1=KycData?.correspondenceAddress1;
    const adress2=KycData?.correspondenceAddress2;
    const permanentadress1=KycData?.permanentAddress1;
    const permanentAddress2=KycData?.permanentAddress2
    
    const pincode=KycData?.correspondencePincode;
    console.log(KycData, "KycData");
    if (KycData.iskycVerified === 0) {
     
      const response = await axios.post(
        `https://1umwbwg2b7.execute-api.ap-south-1.amazonaws.com/Prod/insurance/v1/health/policy/kyc/verification`,
        {payload:encrytedData}
      );
      const decryptedData = decryptData(response);
      console.log("HDFC KYC API response:",decryptedData);  
      const kycFailureData =decryptData(response?.data); 
      console.log(kycFailureData,"ahuhdsi")
      
      
      alert("kyc Failed")
      window.location.href = kycFailureData?.body?.data?.redirect_link;  
      console.log(window.location.href);
      // return decryptedData;
    } else {
      alert("kyc Verified");
      window.location.href = 
      `https://www.lmvinsurance.com/health/hdfckyc?name=${name}&dob=${dob}&kyc_id=${kycId}&Address1=${adress1}&Address2=${adress2}&PermAddress1=${permanentadress1}&permAdress2=${permanentAddress2}&Pincode=${pincode}`;
      // `http://localhost:3000/health/hdfckyc?name=${name}&dob=${dob}&kyc_id=${kycId}&Address1=${adress1}&Address2=${adress2}&PermAddress1=${permanentadress1}&permAdress2=${permanentAddress2}&Pincode=${pincode}`;
      // return response;
    }
  } catch (error) {
    console.error("Error in HDFC KYC API call:", error);
  }
};



export const RelianceKycCall= async (Provider,params)=>{
  
  try {

    const response = await verifyKyc(Provider,params);
console.log(response,"njndsjn")
   const kycData=response?.body;
   const ckycNumber=kycData?.kyc_data?.CKYC?.result?.PERSONAL_DETAILS?.CKYC_NO
 console.log(kycData,"jhcjsdhjhdsj"
 )

   if(kycData?.success===true){
    alert("Kyc Verified");
    window.location.href = `https://www.lmvinsurance.com/health/relianceKyc?ckyc_number=${ckycNumber}`;
    
   }else if(kycData?.success===false){
    alert("kyc Verification Failed")
   window.location.href=kycData?.Endpoint_2_URL;
   }
  } catch (error) {
    console.error("Error in HDFC KYC API call:", error);
  }
}



